module.exports = __webpack_public_path__ + "img/img_occupation_dao.45203cb0.png";